import React from 'react'
import type { DateHeaderProps } from 'react-big-calendar'
import moment from 'moment'
import { makeStyles } from '@paintscout/ui'
import classNames from 'classnames'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.paintscout.palette.brand.Neutral.P50,
    padding: theme.spacing(1.125, 1.5, 1.25, 1.5),
    zIndex: 1000,
    position: 'relative',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    lineHeight: 1
  },
  monthLabel: {
    color: theme.paintscout.palette.brand.Neutral.P50
  },
  label: {
    margin: 0,
    cursor: 'pointer',
    pointerEvents: 'auto',
    color: theme.paintscout.palette.brand.Neutral.P50,
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  today: {
    color: theme.palette.common.white,
    backgroundColor: theme.paintscout.palette.primary,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing(0.25, 0.75),
    fontWeight: 600
  }
}))

export function MonthDateHeader(props: DateHeaderProps) {
  const classes = useStyles()
  const { onDrillDown, label, date, isOffRange } = props
  const isToday = new Date().toDateString() === date.toDateString()
  const isFirstOfMonth = moment(date).date() === 1
  if (isOffRange) {
    return null
  }

  return (
    <div className={classes.root}>
      {isFirstOfMonth && <span className={classes.monthLabel}>{moment(date).format('MMMM')}</span>}
      <span className={classNames({ [classes.label]: true, [classes.today]: isToday })} onClick={onDrillDown}>
        {label}
      </span>
    </div>
  )
}
